.wrap {
  width: 100%;
}
